import React, {useEffect, useRef, useState} from "react";
import SimpleLineIcon from "react-simple-line-icons";
import "./StoreDetail.scss";
import 'swiper/swiper-bundle.min.css'
import Swiper from "swiper";
import SwiperId from 'react-id-swiper';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {
    CheckinMall,
    ConvertToJalali,
    FactorData,
    FestivalsData,
    LastInvoiceData,
    RewardsData,
    StoreData
} from "./StoreDetailServices";
import moment from "moment-jalaali";
import {ConvertTMonthName} from "../../Services/utils";
import Rodal from "rodal";
import 'rodal/lib/rodal.css';
import {TextBreak} from "../../Components";
import {MenuList} from "../Home/Sections";
import {RootData} from "../Menu/MenuServices";
import {useDispatchMall} from "../../hooks";
import useWindowDimensions from "../../hooks/useWindowDimensions";

function StoreDetail() {

    //hooks
    const history = useHistory();
    const location = useLocation();
    const { id } = useParams();
    const setMall = useDispatchMall();

    //states
    const [merchant,setMerchant] = useState({});
    const [showMore,setShowMore] = useState(false);
    const [coordinates,setCoordinates] = useState(null);
    const [rewards,setRewards] = useState([]);
    const [festivals,setFestivals] = useState([]);
    const [invoices,setInvoices] = useState([]);
    const [showModal,setShowModal] = useState(false);
    const [factor,setFactor] = useState({});
    const [rootMenu,set_rootMenu] = useState([]);



    // Fetch Festivals And Rewards ---------------------------------------------
    const getRewards = async (merchantId) => {
        try{
            let response = await RewardsData(merchantId);
            // console.log("Rewards : ", response.data)
            let rewards = response.data.filter(item=>{
                return item.generated_coupon
            })
            setRewards(rewards);
        }catch (e) {
            // console.log(e)
        }
    }

    const getStore = async (merchantId) => {
        try{
            let response = await StoreData(merchantId);
            setMerchant(response.data)
            getFestivals(merchantId);
            getRewards(merchantId);
            getLastInvoice(merchantId);
            getRootMenu(merchantId)
            CheckinMall(response.data.mall.uid)
            localStorage.setItem('mallId',response.data.mall.uid);
            localStorage.setItem('mallLogo',response.data.mall.header_image);
            localStorage.setItem('mallWhite',response.data.mall.logo);
            localStorage.setItem('mallName',response.data.mall.name);
            localStorage.setItem('mall',JSON.stringify(response.data.mall));
            setMall(response.data.mall);
        }catch (e) {
            // console.log(e)
        }
    }

    const getRootMenu = async (merchantId)=>{
        try {
            const response = await RootData(merchantId)
            set_rootMenu(response.data)
        }catch (e) {
            console.log(e)
        }

    }

    const getFestivals = async (merchantId) => {
        try{
            let response = await FestivalsData(merchantId);

            //filter without image
            let festivals = response.data.filter(item=>{
                return item.image || item.cover;
            })

            setFestivals(festivals);
        }catch (e) {
            // console.log(e)
        }
    }

    const getLastInvoice = async (merchantId) => {
        try{
            let response = await LastInvoiceData(merchantId);
            setInvoices(response.data.results.splice(0,2))
        }catch (e) {
            // console.log(e)
        }
    }

    const ConvertToJalaliSplited = (date) =>{
        let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        return day+" "+month+""+year
    }

    const numberWithCommas = (x) => {
        if(x===0){return 0}
        return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
    }


    function numberSubWithCommas(x) {
        // convert To toman
        // x= (x/10).toFixed(0)
        //add commas
        if(x){
            let num = x.split(".");
            return x?num[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
        }else {
            return "0"
        }

    }



    // const imageParams = {
    //     slidesPerView: 2,
    //     spaceBetween: 20,
    //     pagination: {
    //         el: '.swiper-pagination',
    //         clickable: true
    //     }
    // }

    const imageParams = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 10
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 10

            },
            400: {
                slidesPerView: 'auto',
                spaceBetween: 20
            },
            320: {
                slidesPerView: 'auto',
                spaceBetween: 10
            }
        }
    }




    // DualSliderDesktop ---------------------------------------------------------
    const params = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 10
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 10
            },
            400: {
                slidesPerView: 'auto',
                spaceBetween: 20
            },
            320: {
                slidesPerView: 'auto',
                spaceBetween: 10
            }
        }
    }
    const swiper = useRef(null)
    const Loop = ()=>{setInterval(()=>{swiper.current.slideNext();},2000)}


    //Map route ---------------------------------------------------------------
    useEffect(()=>{
        if(location.state){
            if(location.state.merchant){

                //set Merchant data
                setMerchant(location.state && location.state.merchant);
                getStore(location.state.merchant.uid)

                if(location.state.merchant.geometry){
                    // setCoordinates({
                    //     lng:location.state.merchant.geometry.coordinates[0],
                    //     lat:location.state.merchant.geometry.coordinates[1]
                    // })
                }
            }

            if(location.state.store){
                //set Merchant data
                getStore(location.state.store.uid);
            }
        }else {
            // console.log("ID : ",id)
            getStore(id);
        }
    },[location.state])

    //mocks

    // const factor ={
    //     "uid":"fXMYCzuBdR","merchant":{"uid":"C7aKFxwVT6","name":"روژا","thumbnail":"https://s3.mobank.co/loyalty-media/merchant/merchant/images/Roja_Logo_5dteQ6l.jpg","mall":{"uid":"ww8Sa3xrPp","name":"اپال"}},"address":null,"amount":1660647,"discount_amount":0,"payable_amount":0,"state":"success_to_pay","paid_at":"2020-07-29T12:18:23+04:30","purchase_token":null,"description":"","order":{"uid":"4AQgJRY9dc","status":3,"status_label":"finalize_by_user","amount":1660647,"original_amount":1748050,"discount":87402,"description":null,
    //         "items":[
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"ZEMnSVBF3e","name":"لوبیا قرمز 900 گرمی فامیلا","quantity":1,"per_amount":379050,"amount":379050,"product_id":105929,"product":{"uid":"iU6Dj2hS75","name":"لوبیا قرمز 900 گرمی فامیلا","price_original":399000.0,"price":379050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/iU6Dj2hS75"},"per_discount":19950,"discount":19950,"original_amount":399000},
    //             {"uid":"tA6wg2ucuN","name":"مینی تست مخصوص پرونان 400 گرمی نان اوران","quantity":1,"per_amount":54150,"amount":54150,"product_id":105625,"product":{"uid":"4njsWG38hj","name":"مینی تست مخصوص پرونان 400 گرمی نان اوران","price_original":57000.0,"price":54150.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/4njsWG38hj"},"per_discount":2850,"discount":2850,"original_amount":57000},{"uid":"AGu3myb5cj","name":"لوبیا سفید 900  گرمی برتر","quantity":1,"per_amount":287897,"amount":287897,"product_id":105913,"product":{"uid":"4jRvMKDg9Y","name":"لوبیا سفید 900  گرمی برتر","price_original":303050.0,"price":287897.5,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/4jRvMKDg9Y"},"per_discount":15152,"discount":15152,"original_amount":303050},{"uid":"JAMDmsP2xV","name":"نودل 77 گرمی 5 عددی با طعم گوجه فرنگی هاتی کارا","quantity":1,"per_amount":142500,"amount":142500,"product_id":105480,"product":{"uid":"3aKcDRRP6G","name":"نودل 77 گرمی 5 عددی با طعم گوجه فرنگی هاتی کارا","price_original":150000.0,"price":142500.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/3aKcDRRP6G"},"per_discount":7500,"discount":7500,"original_amount":150000},{"uid":"X3KSDp9TEP","name":"روغن کنجدکانولا 1.8 لیتری پیک","quantity":1,"per_amount":797050,"amount":797050,"product_id":105059,"product":{"uid":"EH9jeCFWHH","name":"روغن کنجدکانولا 1.8 لیتری پیک","price_original":839000.0,"price":797050.0,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/EH9jeCFWHH"},"per_discount":41950,"discount":41950,"original_amount":839000}]},"created":"2019-07-30T10:46:07.223297+04:30"}

    const mapsSelector = () =>{
        if(coordinates){
            if /* if we're on iOS, open in Apple Maps */
            ((navigator.platform.indexOf("iPhone") != -1) ||
                (navigator.platform.indexOf("iPad") != -1) ||
                (navigator.platform.indexOf("iPod") != -1))

                window.open("maps://maps.google.com/maps?daddr="+coordinates.lat+","+coordinates.lng+"&amp;ll=");
            else /* else use Google */
                window.open("https://maps.google.com/maps?daddr="+coordinates.lat+","+coordinates.lng+"&amp;ll=");
        }
    }

    // didMount -------------------------------------------------------
    useEffect(()=>{


        //set scroll to top
        window.scrollTo(0, 0)

        //Swiper init
        swiper.current=new Swiper(
            '.swiper-containera',
            {loop:true, autoplay: {delay: 5000,},
            })



    },[]);


    const getFactor = async (id) => {
        try {
            const factor = await FactorData(id);
            setFactor(factor.data);
            setShowModal(true)
        }catch (e) {
            // console.log(e)
        }
    }


    const   HistoryCard = ({item,getFactor}) =>{

        const [load,setLoad] = useState(false)

        return(
            <div  className="storeDetail-history-item" onClick={()=>{
                setLoad(true);
                getFactor(item.uid);
            }}>
                <div className="storeDetail-history-item-price">
                    <i className="fa fa-angle-left"></i>
                    <span>ریال</span>
                    <span> {numberWithCommas(item.amount)}</span>
                </div>
                <div className="storeDetail-history-item-info">
                    <div className="storeDetail-history-item-info-detail">
                        <span className="detail_date">{ConvertToJalaliSplited(item.created)}</span>
                        <span className="detail_factor_number">{` شماره فاکتور ${item.uid}`}</span>
                    </div>
                    <div className="storeDetail-history-item-info-icon">
                        {load?<i className="fa fa-spinner fa-spin" style={{fontSize:28}}></i>:<img src="/other/red_history.png" alt=""/>}
                    </div>
                </div>
            </div>
        )
    }

    const GiftPrice = ({reward})=>{
        return(
            <div className="gift-section-ticket" style={{direction:"ltr"}}>
                <div className="gift-section-ticket-off reward_level_2" style={{margin:"4px 4px 16px 4px"}}>
                                        <span className="gift-section-ticket-off-number">
                                            <span className="off-number">{reward.generated_coupon.discount_value?reward.generated_coupon.discount_value/10000:0}</span></span>
                    <span className="gift-section-ticket-off-label"> ریال</span>
                </div>
                <div className="gift-section-ticket-info">
                    <div className="rotated-half-up-circle"></div>
                    <div className="rotated-half-down-circle"></div>
                    <span className="gift-section-ticket-info-title">{reward.generated_coupon.title}</span>
                    <div className="gift-section-ticket-info-date">
                        <span>{ConvertToJalali(reward.generated_coupon.valid_to_date)}</span>
                        <SimpleLineIcon name="clock" />
                    </div>
                </div>
            </div>
        )
    }

    const { height, width,mobileWidth } = useWindowDimensions();


    const GiftPercent = ({reward})=>{
        return(
            <div className="gift-section-ticket" style={{direction:"ltr"}}>
                <div className="gift-section-ticket-off reward_level_2">
                                        <span className="gift-section-ticket-off-number">
                                            <span className="off-number">{reward.generated_coupon.discount_value>100?100:reward.generated_coupon.discount_value}</span>%</span>
                    <span className="gift-section-ticket-off-label">تخفیف</span>
                </div>
                <div className="gift-section-ticket-info">
                    <div className="rotated-half-up-circle"></div>
                    <div className="rotated-half-down-circle"></div>
                    <span className="gift-section-ticket-info-title">{reward.generated_coupon.title}</span>
                    <span className="gift-section-ticket-info-max">{`تا سقف ${parseInt(reward.generated_coupon.max_discount_amount/10)}  ریال`}</span>
                    <div className="gift-section-ticket-info-date">
                        <span>{ConvertToJalali(reward.generated_coupon.valid_to_date)}</span>
                        <SimpleLineIcon name="clock" />
                    </div>
                </div>
            </div>
        )
    }

    return(
        <div className="storeDetail-container">
            <Rodal animation={"zoom"} visible={showModal} onClose={()=>setShowModal(false)}>
                <div className="factor-header">
                    <div className="factor-header-item left">
                        <span className="factor-header-item-title">تاریخ</span>
                        {factor.created?<span className="factor-header-item-val">{ConvertToJalali(factor.created)}</span>:null}
                    </div>
                    <div className="factor-header-item right">
                        <span className="factor-header-item-title" >شماره فاکتور</span>
                        {factor.uid?<span className="factor-header-item-val">{factor.uid}</span>:null}
                    </div>
                </div>
                <div className="factor-table">
                    <table>
                        <thead>
                        <tr>
                            <th className="product-table-head">جمع کل</th>
                            {/*<th className="product-table-head">تخفیف</th>*/}
                            <th className="product-table-head">تعداد</th>
                            <th className="product-table-head product-table-head-name">نام کالا</th>
                            <th className="product-table-head product-table-head-name">تصویر</th>
                        </tr>
                        </thead>
                        <tbody>
                        {factor.products && factor.products.map(product=>{
                            return(
                                <tr key={product.uid}>
                                    <td className="product-price">{numberWithCommas(product.amount)}</td>
                                    {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                    <td className="product-count">{product.quantity}</td>
                                    <td className="product-name">{product.name}</td>
                                    <td className="product-name">
                                        {product.product?<img src={product.product.image?product.product.image:"/other/skeleton/product.jpg"} alt=""/>:null}
                                    </td>
                                </tr>
                            )
                        })
                    }
                        </tbody>
                    </table>

                    <div className="factor-table-total-row customer_discount-row">
                        <div className="factor-table-total--price customer_discount-val">
                            <span>ریال</span>
                            {<span>{numberWithCommas(factor.discount_amount)}</span>}
                        </div>
                        <span className="customer_discount"> : تخفیف  </span>
                    </div>

                    <div className="factor-table-total-row">
                        <div className="factor-table-total--price">
                            <span>ریال</span>
                            {factor.payable_amount?<span>{numberWithCommas(factor.payable_amount)}</span>:null}
                        </div>
                        <span> : جمع کل  </span>
                    </div>
                </div>

            </Rodal>
            {/*Header*/}
            <div className="storeDetail-header" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                <img src={merchant.mall && merchant.mall.header_image} alt="logo" style={{width:"auto",height:35}}/>
                <i onClick={()=>{
                    history.push(`/store`);
                }}
                   className="fa fa-arrow-left"></i>
            </div>


            {/*DualSliderDesktop*/}
            <div className="storeDetail-slider">
                {merchant && merchant.cover?<div className="swiper-containera swiper1">
                    <div className="swiper-wrapper">
                        <div style={{minWidth:100}} className="swiper-slide"><img src={merchant.cover}/></div>
                    </div>
                </div>:null}
            </div>

            {/*Info*/}
            <div className="storeDetail-info">
                <div className="storeDetail-info-name">
                    <span className="storeDetail-info-name-title">{merchant && merchant.name}</span>
                    <span className="storeDetail-info-name-point">امتیاز شما در این فروشگاه <span>۰</span></span>
                </div>
                <div className="storeDetail-info-logo">
                    <img src={merchant && merchant.thumbnail} alt=""/>
                </div>
            </div>

            {/*Actions*/}
            <div className="storeDetail-actions" style={{marginBottom:0}}>
                <div className="storeDetail-actions-item-back" onClick={()=>{
                    if(merchant.phone){
                        document.location.href="tel:"+merchant.phone;
                    }else {
                        //document.location.href="tel:"+'';
                    }
                }}>
                    <img src="/svg//phone.svg" alt=""/>
                    <span>تماس</span>
                </div>
                <div className="storeDetail-actions-item-back" onClick={()=>mapsSelector()}>
                    <img src="/svg//direction.svg" alt=""/>
                    <span>مسیر یابی</span>
                </div>
                <div className="storeDetail-actions-item-back" onClick={()=>history.push(`/chat/${merchant.topic}`,{merchant:merchant})}>
                    <img src="/svg//chat.png" alt=""/>
                    <span>چت</span>
                </div>
            </div>


            <div className="dg-splitter">
                <hr/>
            </div>



            {/*extra image*/}
            <div className="storeDetail-festival">

                {merchant && merchant.extra_images?<div className="storeDetail-festival-titre">
                    تصاویر
                </div>:null}

                <div className="storyDetail-festival-slider">
                    {/*<SwiperId {...imageParams}>*/}
                    {/*    {merchant && merchant.extra_images.map(extra=>{*/}
                    {/*        return(*/}
                    {/*            <div key={extra.uid} className="OnStore-slide">*/}
                    {/*                <img src={extra.image} alt="" onClick={()=>{*/}
                    {/*                    console.log()*/}
                    {/*                }} />*/}
                    {/*                <div className="festival-slide-title">*/}
                    {/*                    /!*<span>جمعه سیاه</span>*!/*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        )*/}
                    {/*    })}*/}

                    {/*</SwiperId>*/}
                </div>

            </div>


            {/*{merchant ? <MenuList item={{items:[*/}
            {/*        {link_to_uid:merchant.uid}*/}
            {/*    ]}}/>: null}*/}

            {/*Festival*/}
            <div className="storeDetail-festival">

                {festivals.length>0?<div  className="storeDetail-festival-titre">
                    جشنواره ها
                </div>:null}

                <div className="storyDetail-festival-slider">
                    {festivals.length>0? <SwiperId {...imageParams}>
                        {festivals.map(reward=>{
                            return(
                                <div key={reward.uid} className="Store-slide" onClick={()=>{
                                    history.push(`/festival-detail/${reward.uid}`,{festival:{uid:reward.uid}})
                                }}>
                                    <img src={reward.image || reward.cover} alt=""/>
                                    <div className="festival-slide-title">
                                        <span>{reward.title}</span>
                                    </div>
                                </div>
                            )
                        })}
                    </SwiperId>:null}
                </div>

            </div>


            {/*Reward*/}
            <div className="storeDetail-rewards">

                {rewards.length>0?<div className="storeDetail-reward-titre">
                    پاداش ها
                </div>:null}

                {rewards.length>0?<SwiperId {...params}>

                    {rewards.map(reward=>{
                        switch (reward.generated_coupon.coupon_type) {
                            case 'discount_amount':
                                return(
                                    <div  key={reward.uid} className="slider-gift-section">
                                        <GiftPrice reward={reward}/>
                                    </div>
                                )
                                break;
                            default:
                                return(
                                    <div key={reward.uid} className="slider-gift-section">
                                        <GiftPercent reward={reward}/>
                                    </div>
                                )

                        }
                    })}
                </SwiperId>:null}

            </div>

            {/*History*/}

            {invoices.length>0 ? <div className="storeDetail-history">

                <div className="storeDetail-history-titre">
                    <span>تاریخچه خرید من</span>
                </div>


                <div className="storeDetail-history-list">

                    {invoices.map(item=>{
                        return(
                            <HistoryCard key={item.uid} item={item} getFactor={getFactor}/>
                        )
                    })}



                </div>


                <div className="see-more" style={{padding:0}}>
                    <div className="see-more-btn" onClick={()=>{
                        history.push("/reward")
                    }}>
                        <i className="fa fa-angle-left"></i>
                        <span>مشاهده همه صورت حساب ها</span>
                    </div>
                </div>

                <div className="storeDetail-float-btn">
                </div>


            </div>:null}


            {/*About*/}
            <div className="storeDetail-about" style={{paddingBottom:70}}>
                <div className="storeDetail-about-titre">
                    <span>درباره کسب و کار</span>
                </div>

                <div className="storeDetail-about-body">
                    {/*<p>{merchant && merchant.description}</p>*/}
                    {merchant && merchant.description?<TextBreak text={merchant.description}/>:null}
                    {/*<Expand open={showMore}>*/}
                    {/*    <>*/}
                    {/*        <p>{merchant && merchant.description.substring(200, merchant.description.length)}</p>*/}
                    {/*    </>*/}
                    {/*</Expand>*/}
                </div>

                {/*{merchant && merchant.description.length>200?<div className="storeDetail-about-more noselect" onClick={()=>setShowMore(!showMore)}>*/}
                {/*    <i className={showMore?"fa fa-angle-up":"fa fa-angle-down"}></i>*/}
                {/*        <span>نمایش بیشتر</span>*/}
                {/*</div>:null}*/}
            </div>

            <br/>

            <div className="online-store-sec-float" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth,
                position:"fixed",
                bottom:20,
                zIndex:2
            }} >

                {merchant && merchant.online_merchant?<div className="online-store-btn" style={{
                    margin:8
                }}  onClick={()=>{
                    history.push(`/online-store/${merchant.uid}`)
                }}>
                    <span>فروشگاه اینترنتی</span>
                </div>:null}

                {merchant &&
                 merchant.has_menu &&
                rootMenu.length>0?<div className="online-store-btn" style={{
                    margin:8
                }}  onClick={()=>{
                    history.push(`/menu/${merchant.uid}`,{item:{merchantId:merchant.uid,cat:{
                                name: rootMenu[0].title,
                                uid:rootMenu[0].uid
                            },status:"root"}})
                }}>
                    <span>محصولات و خدمات فروشگاه</span>
                </div>:null}

            </div>
        </div>
    )
}

export {StoreDetail};
